import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {AlertService, AuthenticationService} from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { EmployeePtoService } from '../employee-pto.service';
import { EmployeePto } from '../employee-pto';
import { EmployeeProfileService } from '@app/_components/employee-profile/employee-profile.service';
import {first} from 'rxjs/operators';
import {User} from '@app/_models';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-employee-pto',
    templateUrl: './employee-pto.component.html',
    styleUrls: ['./employee-pto.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class EmployeePtoComponent implements OnInit {

  currentUser: User;
  currentUserSubscription: Subscription;
  private loggedInUserProfileId: any;
	constructor(
		private primengConfig: PrimeNGConfig,
		private employeePtoService: EmployeePtoService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private employeeProfileService: EmployeeProfileService,
    	private authenticationService: AuthenticationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.employeePto = data.employeePto,
			this.statuses = employeePtoService.statuses;
			this.ptoReasons = employeePtoService.ptoReasons;
      this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
	}

	@Input() employeePto: EmployeePto;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	employeePtoId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;
	ptoReasons: any;
	employeeProfiles: any;
	employeeProfileId: any;
	approvedBy: any;

	validationMessages = {
		'employeePtoId': [],
		'employeeProfileId':[{ type: 'required', message: 'Required' }],
		'status': [{ type: 'required', message: 'Required' }],
		'startDate': [{ type: 'required', message: 'Required' }],
		'endDate': [{ type: 'required', message: 'Required' }],
		'ptoHours': [{ type: 'required', message: 'Required' }],
		'ptoReason': [{ type: 'required', message: 'Required' }],
		'mgrNotes': [],
		'employeeNotes': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole employeePto object
		if (this.employeePto) {
			this.employeePtoId = this.employeePto.employeePtoId;
			if(this.employeePto.startDate != undefined && this.employeePto.startDate != null){
				this.employeePto.startDate = moment(this.employeePto.startDate).toDate();
			}
			if(this.employeePto.endDate != undefined && this.employeePto.endDate != null){
				this.employeePto.endDate = moment(this.employeePto.endDate).toDate();
			}
			this.form1.patchValue(this.employeePto);
		}
		this.fetchAllEmployees();
		this.fetchLoggedInUserProfile();
	}
	fetchAllEmployees() {
		if (!this.employeeProfiles || this.employeeProfiles === undefined || this.employeeProfiles.length < 1) {
			try {
				this.employeeProfileService.findAllWithoutPage()
					.subscribe(
						res => {
							console.log('employee Profiles: ' + JSON.stringify(res));
							this.employeeProfiles = res.data.employeeProfiles;
              this.employeeProfiles.forEach( (element) => {
                element.fullName = element.firstName+' '+element.lastName;
              });
							return this.employeeProfiles;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.employeeProfiles);
		}

	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.employeePtoId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.employeePtoService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.employeePto = res.data.employeePto;
						this.doAdd.emit(this.employeePto);
					},
					(err: any) => {
						console.log('employeePto-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('employeePto: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
      if ( 2 === this.form1.value.status ){
        this.form1.value.approvedBy = this.loggedInUserProfileId;
      }
			this.employeePtoService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.employeePto = res.data.employeePto;
						this.doUpdate.emit(this.employeePto);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.employeePtoService.delete(this.employeePto.employeePtoId)
				.subscribe(
					(res: any) => {
						console.log('employeePto-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.employeePto);
					},
					(err: any) => {
						console.log('employeePto-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			employeePtoId: [this.employeePtoId],
			employeeProfileId: [this.employeeProfileId, Validators.required],
			approvedBy: [this.approvedBy],
			status: ['',Validators.required],
			requestDate: [moment()],
			startDate: ['',Validators.required],
			endDate: ['',Validators.required],
			ptoHours: ['',Validators.required],
			ptoReason: ['', Validators.required],
			mgrNotes: [],
			employeeNotes: [],
		});
	}
// fetch profile of logged in user to set as approvedby profile
  private fetchLoggedInUserProfile() {
    this.employeeProfileService.findByUserId(this.currentUser.userId).pipe(first()).subscribe(

      data =>
      {
        console.log('taskUser serach: ' + JSON.stringify(data));
        this.loggedInUserProfileId = data.data.employeeProfile.employeeProfileId;
      },
      error =>
      {
        this.alertService.error(error);
      },
      () =>
      { }
    );
  }
}
